var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.showNav == 'hide' ? false : true)?_c('NavBar'):_vm._e(),_c('router-view',{style:(_vm.$route.meta.showNav == 'sub' || _vm.$route.meta.showNav == 'hide'
      ? 'margin-top: 0rem'
      : 'margin-top: 4rem')}),(_vm.$route.meta.showFooter == 'hide' ? false : true)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }